module.exports = __webpack_public_path__ + "img/applicable-1.0ccc73ed.png";